import { useEffect, useState } from 'react';

function AttentionInvestors({ onClose }) {
  return (
    <div className="attention-investors-overlay">
      <div className="attention-investors-box">

        <div className="attention-header text-center">
          <h3>Attention Investors</h3>

          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="attention-content">

         
          <h6>SEBI presents Samajh Se Investing Simple</h6>

          <ul>
            <li>• Understand Before You Invest</li>
            <li>• Choose Regulated Investment Products</li>
            <li>• Start Early, Stay Invested</li>
            <li>• Beware of Investment Frauds</li>
          </ul>

          <h6>सेबी प्रस्तुत करता है : समझ से इन्वेस्टिंग सिंपल</h6>

          <ul>
            <li>• निवेश करने से पहले समझें</li>
            <li>• विनियमित निवेश उत्पाद चुनें</li>
            <li>• जल्दी शुरुआत करें, निवेशित रहें</li>
            <li>• निवेश धोखाधड़ी से सावधान रहें</li>
          </ul>

          <h6>General Investor Information</h6>

          <ol>
            <li>
              1. Stock Brokers can accept securities as margin from clients only
              by way of pledge in the depository system w.e.f. September 1, 2020.
            </li>

            <li>
              2. Update your mobile number &amp; email ID with your stock
              broker/depository participant and receive OTP directly from
              depository on your email ID and/or mobile number to create pledge.
            </li>

            <li>
              3. Pay 20% upfront margin of the transaction value to trade in cash
              market segment.
            </li>

            <li>
              4. Investors may please refer to the Exchange&apos;s Frequently
              Asked Questions (FAQs) issued vide circular reference
              NSE/INSP/45191 dated July 31, 2020 and NSE/INSP/45534 dated
              August 31, 2020 and BSE Vide Notice no-20200731-7 dated July
              31, 2020 and 20200831-45 dated August 31, 2020 and other
              guidelines issued from time to time in this regard.
            </li>

            <li>
              5. Check your Securities / MF / Bonds in the consolidated account
              statement issued by NSDL/CDSL every month.
            </li>
          </ol>

          <h6>RISK DISCLOSURES ON DERIVATIVES</h6>

          <ul>
            <li>
              • 9 out of 10 individual traders in equity Futures and Options
              Segment incurred net losses.
            </li>

            <li>
              • On an average, loss makers registered net trading loss close to
              ₹50,000.
            </li>

            <li>
              • Over and above the net trading losses incurred, loss makers
              expended an additional 28% of net trading losses as transaction
              costs.
            </li>

            <li>
              • Those making net trading profits incurred between 15% to 50% of
              such profits as transaction costs.
            </li>
          </ul>

          <p>
            <strong>
              Source: SEBI study dated January 25, 2023 on “Analysis of Profit
              and Loss of Individual Traders dealing in equity Futures and
              Options (F&amp;O) Segment”, wherein Aggregate Level findings are
              based on annual Profit/Loss incurred by individual traders in
              equity F&amp;O during FY 2021-22.
            </strong>
          </p>

        </div>

        <div className="attention-footer">
          <button className="acknowledge-btn" onClick={onClose}>
            I Understand
          </button>
        </div>

      </div>
    </div>
  );
}

export default AttentionInvestors;